<script>
    import scssData from 'util/dom/scss-data';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [
            bemMixin('sass-data-provider'),
        ],
        props: {
            provide: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isInitialized: false,
                bridgeData: null,
            };
        },
        computed: {
            bridgeClasses() {
                return [
                    this.bemAdd(this.provide),
                ];
            },
            slotProps() {
                return {
                    ...this.bridgeData,
                    ...this.$attrs,
                };
            },
        },
        mounted() {
            this.bridgeData = scssData(this.$el);
            this.isInitialized = true;
        },
        render(createElement) {
            if (this.isInitialized) {
                return this.$scopedSlots.default(this.slotProps);
            }

            return createElement('div', {
                class: [
                    this.bemRoot,
                    ...this.bridgeClasses,
                ],
            });
        },
    };
</script>
